"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteFileMutation = exports.useListFilesQuery = exports.useUploadImageMutation = exports.uploadsApi = void 0;
// api/uploadsApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var API_URL = process.env.API_URL;
if (!API_URL) {
    throw new Error("API_URL environment variable is required");
}
exports.uploadsApi = (0, react_1.createApi)({
    reducerPath: "uploadsApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(API_URL),
    tagTypes: ["uploads"],
    endpoints: function (builder) { return ({
        uploadImage: builder.mutation({
            query: function (file) {
                var formData = new FormData();
                formData.append("image", file);
                return {
                    url: "/v1/uploads/image",
                    method: "POST",
                    body: formData,
                    // RTK Query automatically handles FormData, no need to set Content-Type
                    prepareHeaders: function (headers) {
                        // Remove content-type to let browser set it with boundary for FormData
                        headers.delete("content-type");
                        return headers;
                    },
                };
            },
            invalidatesTags: ["uploads"],
        }),
        listFiles: builder.query({
            query: function () { return ({
                url: "/v1/uploads",
                method: "GET",
            }); },
            providesTags: ["uploads"],
        }),
        deleteFile: builder.mutation({
            query: function (filename) { return ({
                url: "/v1/uploads/".concat(filename),
                method: "DELETE",
            }); },
            invalidatesTags: ["uploads"],
        }),
    }); },
});
exports.useUploadImageMutation = exports.uploadsApi.useUploadImageMutation, exports.useListFilesQuery = exports.uploadsApi.useListFilesQuery, exports.useDeleteFileMutation = exports.uploadsApi.useDeleteFileMutation;
